import React, { createContext, useReducer, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import DeviceConnection from './DeviceConnection'
import { getAdminProfile } from 'redux/reducers/devices'

export const DeviceContext = createContext()

const actionsTypes = {
  SET_IS_ALL_FILTER_SELECTED: 'SET_IS_ALL_FILTER_SELECTED',
  SET_SELECT_USER_VALUE: 'SET_SELECT_USER_VALUE',
  SET_SELECT_LOCATION_VALUE: 'SET_SELECT_LOCATION_VALUE',
  SET_SELECT_PANEL_VALUE: 'SET_SELECT_PANEL_VALUE',
  SET_SELECT_METER_VALUE: 'SET_SELECT_METER_VALUE',
  CLEAR_ALL_FILTER_VALUE: 'CLEAR_ALL_FILTER_VALUE',
  SET_SEARCH_DEVICE_VALUE: 'SET_SEARCH_DEVICE_VALUE',
}

const initialState = {
  isAllFiltersSelected: false,
  selectedUserValue: {},
  selectedLocationValue: {},
  selectedPanelValue: {},
  selectedMeterValue: {},
  searchDeviceValue: '',
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionsTypes.SET_IS_ALL_FILTER_SELECTED:
      return { ...state, isAllFiltersSelected: action.payload }
    case actionsTypes.SET_SELECT_USER_VALUE:
      return {
        ...state,
        selectedUserValue: action.payload,
        selectedLocationValue: initialState.selectedLocationValue,
        selectedPanelValue: initialState.selectedPanelValue,
        selectedMeterValue: initialState.selectedMeterValue,
      }
    case actionsTypes.SET_SELECT_LOCATION_VALUE:
      return {
        ...state,
        selectedLocationValue: action.payload,
        selectedPanelValue: initialState.selectedPanelValue,
        selectedMeterValue: initialState.selectedMeterValue,
      }
    case actionsTypes.SET_SELECT_PANEL_VALUE:
      return {
        ...state,
        selectedPanelValue: action.payload,
        selectedMeterValue: initialState.selectedMeterValue,
      }
    case actionsTypes.SET_SELECT_METER_VALUE:
      return { ...state, selectedMeterValue: action.payload }
    case actionsTypes.CLEAR_ALL_FILTER_VALUE:
      return {
        ...state,
        selectedUserValue: initialState.selectedUserValue,
        selectedLocationValue: initialState.selectedLocationValue,
        selectedPanelValue: initialState.selectedPanelValue,
        selectedMeterValue: initialState.selectedMeterValue,
        isAllFiltersSelected: false,
      }
    case actionsTypes.SET_SEARCH_DEVICE_VALUE:
      return { ...state, searchDeviceValue: action.payload }
    default:
      return state
  }
}

const dispatchActions = (dispatch) => ({
  setIsSelectedAllFiltersValue(payload) {
    return dispatch({ type: actionsTypes.SET_IS_ALL_FILTER_SELECTED, payload })
  },
  setSelectedUserValue(payload) {
    return dispatch({ type: actionsTypes.SET_SELECT_USER_VALUE, payload })
  },
  setSelectedLocationValue(payload) {
    return dispatch({ type: actionsTypes.SET_SELECT_LOCATION_VALUE, payload })
  },
  setSelectedPanelValue(payload) {
    return dispatch({ type: actionsTypes.SET_SELECT_PANEL_VALUE, payload })
  },
  setSelectedMeterValue(payload) {
    return dispatch({ type: actionsTypes.SET_SELECT_METER_VALUE, payload })
  },
  clearAllFiltersValue() {
    return dispatch({ type: actionsTypes.CLEAR_ALL_FILTER_VALUE })
  },
  setSearchDeviceValue(payload) {
    return dispatch({ type: actionsTypes.SET_SEARCH_DEVICE_VALUE, payload })
  },
})

const DeviceConnectionContainer = () => {
  const reduxDispatch = useDispatch()
  const [state, dispatch] = useReducer(reducer, initialState)

  const actions = dispatchActions(dispatch)

  useEffect(() => {
    reduxDispatch(getAdminProfile())
  }, [reduxDispatch])

  useEffect(() => {
    if (
      state.selectedUserValue?.value &&
      state.selectedLocationValue?.value &&
      state.selectedPanelValue?.value &&
      state.selectedMeterValue?.value
    ) {
      actions.setIsSelectedAllFiltersValue(true)
    } else {
      actions.setIsSelectedAllFiltersValue(false)
      actions.setSearchDeviceValue('')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.selectedLocationValue?.value,
    state.selectedMeterValue?.value,
    state.selectedPanelValue?.value,
    state.selectedUserValue?.value,
  ])

  return (
    <DeviceContext.Provider value={{ actions, state }}>
      <DeviceConnection isAllFiltersSelected={state.isAllFiltersSelected} />
    </DeviceContext.Provider>
  )
}

export default DeviceConnectionContainer
